import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import MaintenanceChecker from "v4/features/front/maintenance/MaintenanceChecker/MaintenanceChecker";
import OutdatedFrontChecker from "v4/features/front/appVersion/OutdatedFrontChecker";
import reducer from './reducers';
import './scss/main.scss';
import * as serviceWorker from './serviceWorker';
import './translation';
import AppVersionProvider from "./v4/contexts/AppVersionContext";
import {AuthProvider} from "./v4/contexts/AuthContext";
import NotificationProvider from "./v4/contexts/NotificationContext";
import './v4/utils/debounce.js';
import App from './views/App/App';
import DebugBar from "v4/features/front/debugBar/components/DebugBar/DebugBar";
import DebugBarContext from "v4/features/front/debugBar/contexts/DebugBarContext";

/**
 * @see https://medium.com/@vcarl/performance-profiling-a-redux-app-c85e67bf84ae
 *
 * @returns {function(*): function(*=): (*)}
 */
const userTiming = () => (next) => (action) => {
    if (performance.mark === undefined) return next(action);
    performance.mark(`${action.type}_start`);
    const result = next(action);
    performance.mark(`${action.type}_end`);
    performance.measure(
        `${action.type}`,
        `${action.type}_start`,
        `${action.type}_end`,
    );
    return result;
}

const store = createStore(
    reducer,
    applyMiddleware(thunk, userTiming),
);
ReactDOM.render(
    <DebugBarContext>
        <NotificationProvider>
            <AuthProvider>
                {/* Au-dessus de MaintenanceChecker, qui ne rend pas ses enfants pendant sa sonde initiale */}
                <AppVersionProvider>
                    <MaintenanceChecker>
                        <OutdatedFrontChecker>
                            <Provider store={store}>
                                <App/>
                                {
                                    process.env.REACT_APP_ENV === 'development'
                                    && process.env.REACT_APP_DEBUGBAR_ENABLED === 'true'
                                    && <DebugBar/>
                                }
                            </Provider>
                        </OutdatedFrontChecker>
                    </MaintenanceChecker>
                </AppVersionProvider>
            </AuthProvider>
        </NotificationProvider>
    </DebugBarContext>,
    document.getElementById('root')
)
;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
